import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { updateProps } from '../../../stores/newsfeed/actions';
import { updateProps as updatePostPageProps } from '../../../stores/newsfeed/postPage/actions';
import R from 'ramda';
import ImagePreview from './imagePreview';
import PDFPreview from './pdfPreview';
import PowerPointPreview from './pptPreview';
import VideoPreview from './videoPreview';
import Lightbox from './lightbox';

const FilePreview = props => {
  const {
    files,
    removeFile,
    showGallery, // on thumbnail click, go into gallery
    showFileName,
    updateProp,
    viewingFiles,
    fileToView,
    displayType,
    updatePostPageProp,
    postFilePreview,
    postPreviewFiles,
  } = props;

  const previewFile = displayType === 'publicPostPage' ? postFilePreview : fileToView;
  const postFiles = displayType === 'publicPostPage' ? postPreviewFiles : viewingFiles;
  const onlyOneImageToDisplay = showGallery && R.propOr(0, 'length', files) === 1; // if only 1 image, display larger

  return (
    <div style={{ marginTop: '5px', display: 'flex', width: '100%', overflowY: onlyOneImageToDisplay ? 'hidden' : 'scroll', maxHeight: showGallery && '400px', flexWrap: 'wrap', overflowX: 'hidden' }}>
      {
        files.map((file, i) => {
          const sharedProps = {
            url: file.url,
            removeFile,
            fileName: file.name,
            showFileName,
            showGallery,
            openGallery: () => {
              if (displayType === 'publicPostPage') {
                updatePostPageProp({ postFilePreview: R.merge(file, { index: i }) });
              } else {
                updateProp({ viewingFile: R.merge(file, { index: i }), viewingFiles: files });
              }
              document.getElementById('file-preview-modal').style.display = 'block';
              document.getElementById('file-preview-modal-overlay').style.display = 'block';
            },
            onlyOneImage: onlyOneImageToDisplay,
          };
          return (
            <div key={i} style={{ display: 'inline-block', margin: onlyOneImageToDisplay ? '10px 15px' : '10px' }}>
              {
                R.call(R.cond([
                  [R.either(R.equals('image/png'), R.equals('image/jpeg')), R.always(
                    <ImagePreview
                      src={file.url}
                      thumbnail={file.url}
                      thumbnailWidth={onlyOneImageToDisplay ? 420 : 200}
                      thumbnailHeight={onlyOneImageToDisplay ? 150 : 120}
                      {...sharedProps}
                    />)],
                  [R.equals('application/pdf'), R.always(
                    <PDFPreview {...sharedProps} />)],
                  [R.either(R.equals('video/mp4'), R.equals('video/quicktime')), R.always(
                    <VideoPreview {...sharedProps} />)],
                  [R.either(R.equals('application/vnd.ms-powerpoint'), R.equals('application/vnd.openxmlformats-officedocument.presentationml.presentation')), R.always(
                    <PowerPointPreview {...sharedProps} />)],
                  [R.T, R.always(<span/>)],
                ]), file.mediaType)
              }
            </div>
          );
        })
      }
      {
        showGallery &&
          <Lightbox
            viewingFileIndex={R.propOr(0, 'index', previewFile)}
            changePage={(newIndex) => {
              if (displayType === 'publicPostPage') {
                updatePostPageProp({ postFilePreview: R.merge(postFiles[newIndex], { index: newIndex }) });
              } else {
                updateProp({ viewingFile: R.merge(postFiles[newIndex], { index: newIndex }) });
              }
            }}
            filesLength={postFiles.length}
            viewingFile={previewFile}
            closeLightbox={() => {
              if (displayType === 'publicPostPage') {
                updatePostPageProp({ postFilePreview: {} });
              } else {
                updateProp({ viewingFile: {}, viewingFiles: [] });
              }
              document.getElementById('file-preview-modal').style.display = 'none';
              document.getElementById('file-preview-modal-overlay').style.display = 'none';
            }}
          />
      }
    </div>
  );
};

FilePreview.propTypes = {
  files: PropTypes.array,
  removeFile: PropTypes.func,
  showGallery: PropTypes.bool,
  showFileName: PropTypes.bool,
  updateProp: PropTypes.func,
  fileToView: PropTypes.object,
  viewingFiles: PropTypes.array,
  displayType: PropTypes.string,
  updatePostPageProp: PropTypes.func,
  postFilePreview: PropTypes.object,
  postPreviewFiles: PropTypes.array,
};

const mapStateToProps = ({ newsfeed }) => ({
  fileToView: newsfeed ? newsfeed.get('viewingFile').toJS() : {},
  viewingFiles: newsfeed ? newsfeed.get('viewingFiles').toJS() : [],
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateProps(...args)),
  updatePostPageProp: (...args) => dispatch(updatePostPageProps(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilePreview);



// WEBPACK FOOTER //
// ./src/app/components/extra/filePreview/container.jsx